import React, { useState } from 'react';
import HeaderTitle from '../../../GeneralComponents/HeaderTitle';
import IndexSurveys from './Surveys/Index';
import IndexQuestions from './Questions/Index';
import IndexFormats from './Formats/Index';

const Index = () => {
    const [currentTab, setCurrentTab] = useState("surveys");

    return (
        <React.Fragment>
            <HeaderTitle
                title="Recovery"
                subTitle="Recuperacion de registros eliminados"
            />

            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item" onClick={() => setCurrentTab("surveys")}>
                                    <a className={`nav-link ${currentTab === "surveys" ? 'active' : ''}`} role="tab" style={{ cursor: 'pointer' }}>
                                        <i className="fas fa-clipboard-list mr-1"></i> Registros
                                    </a>
                                </li>

                                <li className="nav-item" onClick={() => setCurrentTab("questions")}>
                                    <a className={`nav-link ${currentTab === "questions" ? 'active' : ''}`} role="tab" style={{ cursor: 'pointer' }}>
                                        <i className="fas fa-question-circle mr-1"></i> Preguntas
                                    </a>
                                </li>

                                <li className="nav-item" onClick={() => setCurrentTab("formats")}>
                                    <a className={`nav-link ${currentTab === "formats" ? 'active' : ''}`} role="tab" style={{ cursor: 'pointer' }}>
                                        <i className="fas fa-file-alt mr-1"></i> Formatos
                                    </a>
                                </li>
                            </ul>

                            <div className="tab-content mt-3">
                                {currentTab === "surveys" && <IndexSurveys />}
                                {currentTab === "questions" && <IndexQuestions />}
                                {currentTab === "formats" && <IndexFormats />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Index;
